import React from 'react';
import ButtonsSearch from '../../../../../../components/NovoSistema/ButtonsSearch';
import { ContainerSection } from '../../../../../../components/NovoSistema/ContainerSection';
import InputDate from '../../../../../../components/NovoSistema/InputDate';
import InputText from '../../../../../../components/NovoSistema/InputText';
import SelectAndOptions from '../../../../../../components/NovoSistema/SelectAndOptions';
import { WrapperInputsNewSystem } from '../../../../../../components/NovoSistema/WrapperInputsNewSystem';

export default function CotacaoDeCompraSearch() {
  return (
    <div>
      <ContainerSection>
        <h3>Pesquisa</h3>
        <WrapperInputsNewSystem>
          <InputDate title="Data Cadastro Inicial" id="DataCadastroInicial" widthPercentage="20%" />
          <InputDate title="Data Cadastro Final" id="DataCadastroFinal" widthPercentage="20%" />
          <InputText title="Número Inicial" id="NumeroInicial" widthPercentage="20%" />
          <InputText title="Número Final" id="NumeroFinal" widthPercentage="20%" />
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <InputDate title="Data Conclusão Inicial" id="DataConclusaoInicial" widthPercentage="20%" />
          <InputDate title="Data Conclusão Final" id="DataConclusaoFinal" widthPercentage="20%" />
          <InputDate title="Data Limite Inicial" id="DataLimiteInicial" widthPercentage="20%" />
          <InputDate title="Data Limite Final" id="DataLimiteFinal" widthPercentage="20%" />
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <SelectAndOptions
            title="Situação"
            id="Situacao"
            optionsArray={[
              '',
              'Todos',
              'Aberta',
              'Enviada',
              'Cancelada',
              'Importada Parcialmente',
              'Finalizada Manualmente',
              'Finalizada',
            ]}
            widthPercentage="20%"
          />
          <InputText title="Parceiro de Negócios" id="ParceiroDeNegocios" widthPercentage="75%" />
        </WrapperInputsNewSystem>
        <ButtonsSearch />
      </ContainerSection>
    </div>
  );
}
